<template>
  <section>
    <validation-observer ref="exerciseForm" #default="{ invalid }">
      <b-form @submit.prevent="exerciseForm" v-if="!loading">
        <b-row>
          <b-col cols="12" xl="9" md="8">
            <b-card>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label=" * نام تمرین"
                    label-for="add-exercise-title"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="title"
                      vid="title"
                      rules="required|min:4"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-exercise-title"
                        v-model="exercise.title"
                        name="add-exercise-title"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group label-for="add-exercise-active">
                    <b-form-checkbox
                      v-model="exercise.active"
                      name="check-active"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      وضعیت تمرین
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group
                    label=" * جریمه (تومان)"
                    label-for="item-penalty"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="item-penalty"
                      vid="item-penalty"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="item-penalty"
                        type="number"
                        v-model="exercise.penalty"
                        min="0"
                        name="item-penalty"
                        :state="errors.length > 0 ? false : null"
                      />

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col>
                  <select-questions
                    :propQuestions="exercise.questions"
                    v-model="exercise.questions"
                  />
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات"
                    label-for="add-exercise-description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                      vid="description"
                    >
                      <editor
                        v-model="exercise.description"
                        :content="exercise.description"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
            <b-card>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                :disabled="invalid"
                type="submit"
              >
                {{ $route.params.id ? "ویرایش تمرین" : "ایجاد تمرین" }}
              </b-button>

              <b-button
                :to="{ name: 'exercises' }"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                block
              >
                برگشت به لیست تمرین ها
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <loader :loading="loading" />
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BBadge,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BImg,
  BCard,
  BCardTitle,
  BFormFile,
  BCardText,
  BModal,
  BListGroupItem,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import Editor from "@/@core/components/editor/Editor.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import SelectQuestions from "./SelectQuestions.vue";
export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BBadge,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormFile,
    BModal,
    BCard,
    Loader,
    SelectBox,
    Editor,
    BListGroupItem,
    SelectQuestions,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      exercise: {
        title: "",
        description: "",
        penalty: "",
        active: 0,
        questions: [],
      },
      loading: false,
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getExercise();
    }
  },
  methods: {
    uploadImage(e) {
      this.exercise.banner = e;
    },
    async getExercise() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/exercises/${this.$route.params.id}?includes=questions`
        );

        await Object.keys(data.data).map((item) => {
          item == "active"
            ? (this.exercise[item] = data.data[item] ? 1 : 0)
            : item == "questions"
            ? (this.exercise[item] = data.data[item].questions.map(
                (question, index) => {
                  return {
                    active: question.active ? 1 : 0,
                    question: question.question,
                    response: question.response,
                    type: String(question.type),
                    items: question.items,
                    sort: index + 1,
                    id: question.id,
                  };
                }
              ))
            : (this.exercise[item] = data.data[item]);
        });
        delete this.exercise.has_answer;
        delete this.exercise.pivot;
        delete this.exercise.times;
      } catch (err) {}
      this.loading = false;
    },
    exerciseForm() {
      this.$refs.exerciseForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          const exercise = await { ...this.exercise };

          exercise.questions = await [];
          await this.exercise.questions.forEach(async (item, index) => {
            if (item.items && item.items.length == 0) {
              delete item.items;
            }
            if (!item.response) {
              delete item.response;
            }
            if (item.type == 2) {
              delete item.items;
            }
            item.sort = index + 1;
            // item.id ? (params["_method"] = "put") : "";
            // const { data } = await this.$http.post(`/panel/questions`, item);
            await exercise.questions.push(item);
          });
          if (!exercise.description) {
            delete exercise.description;
          }
          if (!exercise.questions) {
            delete exercise.questions;
          }
          await setTimeout(async () => {
            try {
              if (this.$route.params.id) {
                const { data } = await this.$http.post(
                  `/panel/exercises/${this.$route.params.id}`,
                  exercise,
                  {
                    params: {
                      _method: "put",
                    },
                  }
                );
                await this.getExercise();
              } else {
                const { data } = await this.$http.post(
                  `/panel/exercises`,
                  exercise
                );
                this.exercise = {
                  title: "",
                  description: "",
                  active: 0,
                  questions: [],
                };
              }

              this.loading = false;
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: `اطلاعات شما با موفقیت ثبت شد.`,
                    icon: "CoffeeIcon",
                    variant: "success",
                  },
                },
                { position: "bottom-right" }
              );
            } catch (err) {
              this.loading = false;
            }
          }, 1000);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0;
  }
}
</style>
